import type { BrandedFare } from '@/app/api/hotel-detail/branded-fares/route';

/**
 * Folds the selected branded fare's package price into a mealPlan-shaped object so
 * every price component (headline, total, taxes breakdown) reads one consistent value.
 *
 * finalPrice / finalTotalPrice come from the fare. priceWithoutTaxes, which the "total incl.
 * local fees" line and the price breakdown add the fees to, moves by the same amount as
 * the headline: the fare only changes the flight, so excludedCharges stays at the base
 * mealPlan. Both the branded-fare price and its package total are already fetched
 * client-side via useBrandedFares, so this needs no network call.
 */
export function mergeBrandedFareIntoMealPlan(
  mealPlan: MealPlanType,
  selectedBrandedFare: BrandedFare | undefined
): MealPlanType {
  const finalPrice = selectedBrandedFare?.finalPrice || mealPlan.finalPrice;
  return {
    ...mealPlan,
    finalPrice,
    finalTotalPrice: selectedBrandedFare?.finalTotalPrice || mealPlan.finalTotalPrice,
    priceWithoutTaxes: mealPlan.priceWithoutTaxes + finalPrice - mealPlan.finalPrice,
  };
}
